export const formatZIP = (ZIP: string) => {
	if (ZIP.length === 5) {
		return ZIP;
	} else {
		return ZIP.substring(0, 5) + "-" + ZIP.substring(5);
	}
};
